import http from "./http.service";

/**
 * Created by zura on 15.04.20.
 */
const ActivityService = {
  async getActivities(params = null) {
    return http.get('/api/v1/activity/', {params});
  },
};

export default ActivityService;
